import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

import vue from '../../../adapter-vue';
import TUIChatEngine, {
  IConversationModel,
  TUIStore,
  StoreName,
} from '../../../@aidesk/uikit-engine';
import EmojiPicker from './emoji-picker/index.vue';
import ImageUpload from './image-upload/index.vue';
import FileUpload from './file-upload/index.vue';
import VideoUpload from './video-upload/index.vue';
import RatingTool from './rating-tool/index.vue';
import { isPC, isH5 } from '../../../utils/env';
import { ToolbarDisplayType, InputToolbarModel } from '../../../interface';
import UserDefineTool from './user-define-input-tool.vue'
import { INPUT_TOOLBAR_TYPE } from '../../../constant';
interface IProps {
  displayType: ToolbarDisplayType;
  isH5EmojiShow?: boolean;
  isH5ToolShow?: boolean;
  inputToolbarList?: InputToolbarModel[];
}
interface IEmits {
  (e: 'scrollToLatestMessage'): void;
  (e: 'changeToolbarDisplayType', type: ToolbarDisplayType): void;
  (e: 'insertEmoji', emoji: any): void;
  (e:'sendMessage'):void;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'index-web',
  props: {
    displayType: { default: 'none' },
    isH5EmojiShow: { type: Boolean, default: false },
    isH5ToolShow: { type: Boolean, default: false },
    inputToolbarList: {}
  },
  emits: ["scrollToLatestMessage", "changeToolbarDisplayType", "insertEmoji", "sendMessage"],
  setup(__props: any, { emit: __emit }) {

const { ref, onMounted, onUnmounted, watch } = vue;

const props = __props;

const emits = __emit;
const h5Dialog = ref<HTMLElement>();
const currentConversation = ref<IConversationModel>();
const isGroup = ref<boolean>(false);
const emojiPickerRef = ref<InstanceType<typeof EmojiPicker>>();
const isInHumanService = ref(false);

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
  TUIStore.watch(StoreName.CUSTOM, {
    isInHumanService: onInHumanServiceUpdate,
  });
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
  TUIStore.unwatch(StoreName.CUSTOM, {
    isInHumanService: onInHumanServiceUpdate,
  });
});

watch(
  () => props.displayType,
  (newValue) => {
    if (newValue === 'none') {
      emojiPickerRef.value?.closeEmojiPicker();
    } else {
      emits('scrollToLatestMessage');
    }
  },
);

watch(
  () => props.isH5EmojiShow,
  (newValue) => {
    if (newValue === false) {
      emojiPickerRef.value?.closeEmojiPicker();
    }
  },
);

const onCurrentConversationUpdate = (conversation: IConversationModel) => {
  currentConversation.value = conversation;
  isGroup.value
    = currentConversation?.value?.type === TUIChatEngine.TYPES.CONV_GROUP;
};

const onInHumanServiceUpdate = (data: {conversationID: string, value: boolean}) => {
  if (data && data.conversationID === currentConversation.value.conversationID) {
    isInHumanService.value = data.value;
  }
};

const insertEmoji = (emojiObj: object) => {
  emits('insertEmoji', emojiObj);
};

const sendMessage = () =>{
  emits('sendMessage');
}

const dialogShowInH5 = (dialogDom: any) => {
  if (!isH5) {
    return;
  }
  h5Dialog.value?.appendChild && h5Dialog.value?.appendChild(dialogDom);
};

const dialogCloseInH5 = (dialogDom: any) => {
  if (!isH5) {
    return;
  }
  if (dialogDom) {
    h5Dialog.value?.removeChild && h5Dialog.value?.removeChild(dialogDom);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'message-input-toolbar',
      !_unref(isPC) && 'message-input-toolbar-h5',
    ])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'message-input-toolbar-list',
        !_unref(isPC) && 'message-input-toolbar-h5-list',
      ])
    }, [
      (props.inputToolbarList === undefined)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_unref(isPC))
              ? (_openBlock(), _createBlock(EmojiPicker, {
                  key: 0,
                  ref_key: "emojiPickerRef",
                  ref: emojiPickerRef,
                  onInsertEmoji: insertEmoji,
                  onDialogShowInH5: dialogShowInH5,
                  onDialogCloseInH5: dialogCloseInH5,
                  onChangeToolbarDisplayType: _cache[0] || (_cache[0] = 
            (type) => emits('changeToolbarDisplayType', type)
          ),
                  isH5EmojiShow: __props.isH5EmojiShow,
                  onSendMessage: sendMessage
                }, null, 8, ["isH5EmojiShow"]))
              : _createCommentVNode("", true),
            _createVNode(ImageUpload, {
              imageSourceType: "album",
              isH5ToolShow: __props.isH5ToolShow
            }, null, 8, ["isH5ToolShow"]),
            _createVNode(FileUpload, { isH5ToolShow: __props.isH5ToolShow }, null, 8, ["isH5ToolShow"])
          ], 64))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(props.inputToolbarList, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (_unref(isPC) && item.presetId === _unref(INPUT_TOOLBAR_TYPE).EMOJI && item.isEnabled === 1)
                ? (_openBlock(), _createBlock(EmojiPicker, {
                    key: 0,
                    ref_for: true,
                    ref_key: "emojiPickerRef",
                    ref: emojiPickerRef,
                    onInsertEmoji: insertEmoji,
                    onDialogShowInH5: dialogShowInH5,
                    onDialogCloseInH5: dialogCloseInH5,
                    onChangeToolbarDisplayType: _cache[1] || (_cache[1] = 
            (type) => emits('changeToolbarDisplayType', type)
          ),
                    isH5EmojiShow: __props.isH5EmojiShow,
                    onSendMessage: sendMessage
                  }, null, 8, ["isH5EmojiShow"]))
                : (item.presetId === _unref(INPUT_TOOLBAR_TYPE).IMAGE && item.isEnabled === 1)
                  ? (_openBlock(), _createBlock(ImageUpload, {
                      key: 1,
                      imageSourceType: "album",
                      isH5ToolShow: __props.isH5ToolShow,
                      title: item.title
                    }, null, 8, ["isH5ToolShow", "title"]))
                  : (item.presetId === _unref(INPUT_TOOLBAR_TYPE).FILE && item.isEnabled === 1)
                    ? (_openBlock(), _createBlock(FileUpload, {
                        key: 2,
                        isH5ToolShow: __props.isH5ToolShow,
                        title: item.title
                      }, null, 8, ["isH5ToolShow", "title"]))
                    : (item.presetId === _unref(INPUT_TOOLBAR_TYPE).VIDEO && item.isEnabled === 1)
                      ? (_openBlock(), _createBlock(VideoUpload, {
                          key: 3,
                          videoSourceType: "album",
                          isH5ToolShow: __props.isH5ToolShow,
                          title: item.title
                        }, null, 8, ["isH5ToolShow", "title"]))
                      : (item.presetId === _unref(INPUT_TOOLBAR_TYPE).RATING && item.isEnabled === 1 && _unref(isInHumanService))
                        ? (_openBlock(), _createBlock(RatingTool, {
                            key: 4,
                            isH5ToolShow: __props.isH5ToolShow,
                            title: item.title
                          }, null, 8, ["isH5ToolShow", "title"]))
                        : (item.isEnabled === 1 && item.isPreset === 0 && item.presetId !== _unref(INPUT_TOOLBAR_TYPE).EMOJI)
                          ? (_openBlock(), _createBlock(UserDefineTool, {
                              key: 5,
                              isH5ToolShow: __props.isH5ToolShow,
                              title: item.title,
                              icon: item.icon,
                              type: item.type,
                              content: item.content
                            }, null, 8, ["isH5ToolShow", "title", "icon", "type", "content"]))
                          : _createCommentVNode("", true)
            ], 64))
          }), 256))
    ], 2),
    (_unref(isH5))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "h5Dialog",
          ref: h5Dialog,
          class: _normalizeClass(['message-input-toolbar-h5-dialog'])
        }, null, 512))
      : _createCommentVNode("", true)
  ], 2))
}
}

})